<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>电信卡订单</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <el-card shadow="hover">
      <el-form :inline="true" size="small" v-model="listQuery">
        <el-form-item label="订单状态">
          <el-select v-model="listQuery.orderStatus" clearable placeholder="请选择" filterable>
            <el-option v-for="(item,index) in orderStatusMap" :key="index" :label="item" :value="index"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="订单编号">
          <el-input v-model="listQuery.orderNo" placeholder="订单编号" clearable></el-input>
        </el-form-item>
        <el-form-item label="服务者编号">
          <el-input v-model="listQuery.workerNo" placeholder="请输入服务者编号" clearable></el-input>
        </el-form-item>
        <el-form-item label="办理人姓名">
          <el-input v-model="listQuery.name" placeholder="请输入办理人姓名" clearable></el-input>
        </el-form-item>
        <el-form-item label="办理人电话">
          <el-input v-model="listQuery.contactMobile" placeholder="请输入办理人电话" clearable></el-input>
        </el-form-item>


        <el-form-item label="下单时间">
          <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="listQuery.createTime" type="daterange"
                          range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                          :picker-options="pickerOptions"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-search" type="primary" plan @click="querySearch">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-search" type="primary" plan @click="exportData">导出</el-button>
        </el-form-item>
        <br/>
      </el-form>
      <!-- 列表数据 -->
      <el-table :data="listData" border style="width: 100%" class="table">
        <el-table-column prop="id" label="ID" width="50px" fixed="left"></el-table-column>
        <el-table-column prop="name" label="用户姓名" width="60px" fixed="left" >
        </el-table-column>
        <el-table-column prop="workerNo" label="服务者编号"></el-table-column>
        <el-table-column prop="idCard" label="身份证号" width="150px"></el-table-column>
        <el-table-column prop="address" label="收货地址" width="300px"></el-table-column>
        <el-table-column prop="contactMobile" label="手机号"  width="100px"></el-table-column>
        <el-table-column prop="freightVendor" label="物流公司"  width="100px"></el-table-column>
        <el-table-column prop="freightCode" label="物流单号"  width="100px"></el-table-column>
        <el-table-column prop="number" label="入网手机号" width="100px"></el-table-column>
        <el-table-column prop="orderStatus" label="订单状态">
          <template slot-scope="scope">
            <el-tag :type="scope.row.orderStatus==0?'success':'danger'"> {{ orderStatusMap[scope.row.orderStatus] }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="orderNo" label="订单编号" width="100px">
        </el-table-column>
        <el-table-column prop="propertyValue" width="300px" label="套餐类型">
        </el-table-column>
        <el-table-column prop="createTime" :formatter="dateFormatA" label="下单时间"></el-table-column>
        <el-table-column label="操作" fixed="right" width="200">
          <template slot-scope="scope">
            <el-button type="text" @click="toInfo(scope.row)" size="mini">查看办理结果</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <pagination :total="total" :page.sync="listQuery.pageNum" :limit.sync="listQuery.pageSize"
                  @pagination="querySearch"/>

    </el-card>


  </div>

</template>
<script>
import moment from "moment";
import Pagination from "../common/Pagination";
import wmsApi from "@/script/api/wmsApi";
import globalData from "@/components/common/globaldata/global.data.vue";
import addOrderForm from "./components/addOrderForm.vue";
import "./css/index.css";
import url from "@/script/baseUrl.js";
import Service from "@/script/api/service";

export default {
  components: {Pagination, addOrderForm},
  filters: {
    formatDate(time) {
      return moment(time).format("YYYY-MM-DD");
    }
  },
  data() {
    return {
      tempRow: {},
      isShowPay: false,
      isShowCancel: false,
      isShowDetail: false,
      isShowAudit: false,
      isShowRebuy: false,
      orderDetailList: [],
      orderInfo: {
        order: {},
        goodsList: [{
          createTime: "",
          skuId: "",
          skuName: "",
          attributes: "",
          buyNumber: "",
          buyPrice: "",
          rentPrice: ""
        }],
        lease: {},
      },
      payData: {
        orderId: null,
      },
      cancelData: {
        orderId: null,
        cancelReason: null,
      },
      orderStatusMap: {
        0: "办理成功",
        1: "办理中"
      },

      total: 0,
      listData: [],
      listQuery: {
        pageNum: 0,
        pageSize: 10,
        endTime: null,
        startTime: null,
        orderStatus: null,
        workerNo: this.$route.query.workerNo,
        createTime:[],
        serialNumber:'',
        contactMobile:'',
        name:''
      },
      orderForm: {
        cityId: null,
        stationId: null,
        workerNoList: []
      },
      rebuyFailLis: [],
      workerList: [],
      stationList2: [],
      cityList: [],
      stationList: [],
      queryStationList: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(
                start.getTime() - 3600 * 1000 * 24 * 7
              );
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近半个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(
                start.getTime() - 3600 * 1000 * 24 * 15
              );
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(
                start.getTime() - 3600 * 1000 * 24 * 30
              );
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      applyAuditForm: {
        orderId: null,
        auditStatus: 1,
        auditRemark: "",
      },
      applyAuditRules: {
        auditStatus: [
          {
            required: true,
            message: "请选择审核状态",
            trigger: "change",
          },
        ],
        auditRemark: [
          {
            required: true,
            message: "请输入备注",
            trigger: "change",
          },
        ],
      },
    };
  },
  created() {
    this.querySearch();
  },
  methods: {
    toInfo(row) {
      console.log(row);
      wmsApi.$ajaxgetResultInfo({serialNumber:row.serialNumber}).then((res) => {
        if (res.data.errno == 0) {
          this.$alert(res.data.data.msg, '办理结果', {
            confirmButtonText: '确定',
            callback: action => {
              this.querySearch()
            }
          });
        }else if (res.data.errno == -1) {
          this.$message.warning(res.data.data + ' !');
        }

      })
        .catch((err) => {
          console.log(err);
        });
    },
    querySearch() {
      console.log(this.listQuery.createTime);
      if (this.listQuery.createTime.length > 0) {
        this.listQuery.startTime =
          this.listQuery.createTime[0] + " 00:00:00";
        this.listQuery.endTime =
          this.listQuery.createTime[1] + " 23:59:59";
      } else {
        this.listQuery.startTime = null;
        this.listQuery.endTime = null;
      }
      wmsApi
        .$ajaxgetTelecomCardPageList(this.listQuery)
        .then((res) => {
          this.listData = res.data.data.list;
          this.total = res.data.data.total;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    exportData(){
      console.log(this.listQuery.createTime);
      if (this.listQuery.createTime.length > 0) {
        this.listQuery.startTime =
          this.listQuery.createTime[0] + " 00:00:00";
        this.listQuery.endTime =
          this.listQuery.createTime[1] + " 23:59:59";
      } else {
        this.listQuery.startTime = null;
        this.listQuery.endTime = null;
      }
      this.listQuery.isExport=true
      wmsApi.$ajaxgetTelecomCardPageListExport(this.listQuery)
      this.listQuery.isExport=false
    }
  },
};
</script>
